module.exports = __webpack_public_path__ + "img/shopify.293018f3.svg";